import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CustomEventService } from '@shared/services/custom-event.service';
import { ImageService } from '@shared/services/image.service';

import { beforeUploadImage, uploadImage } from '@shared/utils/image-upload.util';
import { createImageUrl } from '@shared/utils/object-mapper.util';
import { validateFormGroup } from '@shared/utils/form.util';

import ActionTypesEnum from '@shared/enums/action-constant.enum';

import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { PropertiesService } from "@core/services/properties.service";

@Component({
  selector: 'app-add-addon-modal',
  templateUrl: './add-addon-modal.component.html'
})
export class AddAddonModalComponent implements OnInit {
  @Input() categories;
  addAddonForm: FormGroup;

  loading: boolean;
  imageLoading: boolean;

  constructor(private customEventService: CustomEventService,
              private fb: FormBuilder,
              private nzMessageService: NzMessageService,
              private imageService: ImageService,
              public propertiesService: PropertiesService) { }

  customImageUploadRequest = (item: NzUploadXHRArgs) => uploadImage(
    item,
    this.imageService,
    this.nzMessageService,
    this.imageLoading,
    (imageUrl) => this.addAddonForm.get('iconPath').setValue(imageUrl)
  );

  beforeUpload = (file: NzUploadFile) => beforeUploadImage(file, this.nzMessageService);

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    let iconPath = '';

    if (iconPath) {
      iconPath = createImageUrl(iconPath);
    }

    this.addAddonForm = this.fb.group({
      name: [null, [Validators.required]],
      shortDescription: [null, [Validators.required]],
      category: [null, [Validators.required]],
      iconPath: [iconPath, []]
    });
  }

  submitForm(): void {
    validateFormGroup(this.addAddonForm);

    if (this.addAddonForm.invalid) {
      return;
    }

    const formData = this.addAddonForm.value;

    this.customEventService.announceEvent(ActionTypesEnum.CREATE_ADDON, formData);
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  resetForm(): void {
    this.createForm();
  }
}
